import React, { ReactElement, useState } from 'react';

import * as S from './AdhdCard.styles';

type AdhdCardProps = {
  title: string;
  description: string;
  imageSrc: string;
}

export const AdhdCard = ({ title, description, imageSrc }: AdhdCardProps): ReactElement => {
  const [showFullDescription, setShowFullDescription] = useState(false);

  const handleMoreClick = () => {
    setShowFullDescription(true);
  };

  return (
    <S.Wrapper>
      <S.IconImage src={imageSrc} />
      <S.Title>
        {title}
      </S.Title>
      <S.Description expanded={showFullDescription}>
        {description}
      </S.Description>
      {!showFullDescription && (
        <S.ButtonLink onClick={handleMoreClick}>
          MORE
        </S.ButtonLink>
      )}
    </S.Wrapper>
  );
};
